import React from 'react';

import DropButton from '@components/dropButton';

import useCreateApplication, { Form } from '@pages/Applications/containers/CreateApplication/hooks';

function CreateApplication() {
	const { forms, disabled, loading, handleCreateApplication, isHidden } = useCreateApplication();

	return isHidden ? null : (
		<DropButton<Form>
			label={'Start New Application'}
			options={forms.map(form => ({ id: form.id, label: form.label, data: form }))}
			onSelect={option => handleCreateApplication(option.data)}
			isLoading={loading}
			disabled={disabled}
		/>
	);
}

export default CreateApplication;
